// extracted by mini-css-extract-plugin
module.exports = {"label":"CheckboxGroup__label__nLqPr"};